import { plural } from '@cian/utils';

export const formatFloors = (floorCount: number | undefined, hasMansard?: boolean) => {
  if (!floorCount && !hasMansard) {
    return;
  }

  let result = floorCount !== undefined ? `${floorCount} ` + plural(floorCount, ['этаж', 'этажа', 'этажей']) : '';

  if (hasMansard) {
    result += result.length ? ' и мансарда' : 'мансарда';
  }

  return result;
};
